const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function shouldSendError(type, message) {
    try {
        const key = `error_${type}_${window.btoa(message).slice(0, 12)}`;
        const saved = localStorage.getItem(key);
        const now = Date.now();

        if (saved && now - Number(saved) < 3600000*4) return false;

        localStorage.setItem(key, now.toString());
        return true;
    } catch (e) {
        // fallback: always allow if localStorage fails
        return true;
    }
}

/**
 * Sends error to backend /api/log-error/
 */
function sendErrorLog(payload) {
    fetch(`${API_BASE_URL}/api/log-error/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
}

// Global window error handler
window.onerror = function (message, source, lineno, colno, error) {
    const type = "client_js_error";
    const finalMessage = message || "Unknown JS error";

    if (!shouldSendError(type, finalMessage)) return;

    sendErrorLog({
        type,
        message: finalMessage,
        source: source || window.location.href,
        lineno: lineno || 0,
        colno: colno || 0,
        stack: window.btoa(error?.stack || new Error().stack || ""),
        url: window.location.href,
        user_agent: navigator.userAgent,
    });
};

// Global unhandled promise rejection handler
window.addEventListener("unhandledrejection", function (event) {
    const type = "unhandledrejection";
    const message = event.reason?.message || String(event.reason);

    if (!shouldSendError(type, message)) return;

    sendErrorLog({
        type,
        message,
        stack: window.btoa(event.reason?.stack || ""),
        url: window.location.href,
        user_agent: navigator.userAgent,
    });
});
